var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.7 162.7",
    style: {
      enableBackground: "new 0 0 162.7 162.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E1262D;stroke:#3B3C3C;stroke-width:5.6693;stroke-miterlimit:10;}\n\t.st2{fill:#F9D8D9;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:#FBE6E7;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#3B3C3C;stroke-width:2.8346;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:#3B3C3C;}\n\t.st6{fill:#54494B;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:#F6C5C9;}\n\t.st8{fill:#E1262D;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.15
    },
    width: 169,
    height: 170,
    xlinkHref: "DAFE2CB2C1608EE6.png",
    transform: "matrix(1 0 0 1 -3.5039 -0.8039)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.3,
    cy: 81.3,
    r: 75.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,81.5l-21.7,3.5c0,0,0,0.1,0,0L127.5,78L33.9,81.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 123.7,
    cy: 106.1,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 38.5,
    cy: 106.6,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122,82.3L122,82.3c0-20.1-18.5-36.4-41.3-36.4S39.4,62.2,39.4,82.3v17.5h0c0.1,20,18.6,36.2,41.3,36.2 s41.2-16.2,41.3-36.2h0V82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.7,113.4c0,0,0.1,3.3,5,3.3c4.9,0,4.8-3.3,4.8-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58,92.3c1.4-3,4.9-5.2,9-5.2c3.3,0,6.2,1.4,7.9,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.4,92.3c-1.4-3-4.9-5.2-9-5.2c-3.3,0-6.2,1.4-7.9,3.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 68.2,
    cy: 99.5,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 93.2,
    cy: 99.5,
    r: 3.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M42.8,80.2c0,0,2.8,5.2,10.3,4.5s15.1-8.9,15.1-8.9s1.8,4.6,6.8,4.6c4.9,0,6.5-4.6,6.5-4.6s0.5,4.3,5.5,4.3 c5.1,0,7.8-4.3,7.8-4.3s6.6,9.1,14.1,9.1c7.5,0,11.4-6,11.4-6v16.6c4.6-6.1,7.2-13.4,7.2-21.2c0-22-20.9-39.9-46.8-39.9 S33.9,52.1,33.9,74.1c0,8.7,3.3,16.8,8.9,23.4V80.2z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 101.2,
    cy: 111.4,
    rx: 6.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 60.2,
    cy: 111.4,
    rx: 6.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32.4,55.3c-0.4-7.5,2.2-14.7,7.3-20.3c5.1-5.6,12-8.8,19.6-9.2l37.7-1.9c0.5,0,1,0,1.5,0 c15.1,0,27.5,11.7,28.3,26.6l1.4,27.2L108,79.2c-0.1,0-0.3,0-0.4,0l-0.4-5.7l0.3,0c1.3-0.2,2.2-1.2,2.1-2.5l-0.1-2.4 c-0.1-1.3-1.1-2.3-2.4-2.3l-0.1,0l-2.8,0.1l-0.2-2.8l-0.4-6.9c-0.3-6.3-5.5-11.2-11.9-11.2c-0.2,0-0.4,0-0.6,0 c-3.2,0.2-6.1,1.5-8.3,3.9c-2.1,2.3-3.2,5.3-3.1,8.5l0.5,9.7L77.3,68c-0.7,0-1.4,0.3-1.8,0.8c-0.4,0.5-0.7,1.1-0.6,1.7l0.1,2.4 c0.1,1.3,1.1,2.3,2.4,2.3l0.1,2.8l-0.1-2.8l0.1,0l0.3,5.7l-44.1,1.7L32.4,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M98.4,26.7c13.5,0,24.7,10.5,25.4,23.9l1.3,24.4l-17.4,1.4c2.8-0.3,4.8-2.7,4.7-5.5l-0.1-2.4 c-0.1-2.8-2.5-5-5.3-5c-0.1,0-0.2,0-0.3,0l-0.1,0l-0.4-6.9c-0.4-7.8-6.9-13.9-14.7-13.9c-0.3,0-0.5,0-0.8,0 c-8.2,0.4-14.4,7.3-14,15.4l0.4,6.9l-0.1,0c-2.9,0.1-5.2,2.6-5,5.5l0.1,2.4c0.1,2.8,2.5,5,5.3,5c0,0,0.1,0,0.1,0l-41.2,1.6 l-1.3-24.4c-0.7-13.9,10.1-25.8,24.2-26.5l37.7-1.9C97.5,26.7,98,26.7,98.4,26.7 M107.7,76.4c-0.1,0-0.2,0-0.3,0L107.7,76.4  M77.7,78c0,0-0.1,0-0.1,0L77.7,78 M98.4,21c-0.5,0-1.1,0-1.6,0L59.1,23c-17.2,0.9-30.4,15.4-29.6,32.5l1.3,24.4l0.3,5.6l5.6-0.2 l41.1-1.6c0.1,0,0.2,0,0.2,0l-0.5-11.3c0.2,0,0.3,0.2,0.3,0.4l-0.1-2l5.4-0.3l-0.3-5.7L82.5,58c-0.3-4.9,3.6-9.1,8.6-9.4 c0.2,0,0.3,0,0.5,0c4.8,0,8.8,3.7,9.1,8.5l0.4,6.9l0.3,5.7l5.4-0.3l0.1,2c0-0.2,0.1-0.3,0.2-0.4l0.7,11.3c0.2,0,0.4,0,0.5,0 l17.3-1.4l5.5-0.4l-0.3-5.5l-1.3-24.4C128.7,33.9,115,21,98.4,21L98.4,21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M75.2,84.4c-4.7,0-8.6-3.7-8.9-8.4l-0.1-2.8c-0.3-4.9,3.5-9.1,8.4-9.3l34-1.7c0.2,0,0.3,0,0.5,0 c4.7,0,8.6,3.7,8.9,8.4l0.1,2.8c0.1,2.4-0.7,4.6-2.3,6.4c-1.6,1.8-3.8,2.8-6.1,2.9l-34,1.7C75.5,84.4,75.3,84.4,75.2,84.4z  M77.7,73.6c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.4-0.2,0.3-0.4C78,73.7,77.9,73.6,77.7,73.6L77.7,73.6z  M87.5,73.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.2,0.3,0.3,0.3c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.2 C87.9,73.2,87.7,73.1,87.5,73.1L87.5,73.1z M97.4,72.6c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.4-0.2,0.3-0.4 C97.7,72.7,97.6,72.6,97.4,72.6L97.4,72.6z M107.2,72.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.4-0.2,0.3-0.4 C107.6,72.2,107.4,72.1,107.2,72.1L107.2,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109,64.9c3.2,0,5.9,2.5,6,5.7l0.1,2.8c0.2,3.3-2.4,6.2-5.7,6.4l-34,1.7c-0.1,0-0.2,0-0.3,0 c-3.2,0-5.9-2.5-6-5.7L69,73c-0.2-3.3,2.4-6.2,5.7-6.4l34-1.7C108.8,64.9,108.9,64.9,109,64.9 M107.2,75.6c0.1,0,0.1,0,0.2,0 c1.8-0.1,3.1-1.6,3-3.3c-0.1-1.7-1.5-3-3.2-3c-0.1,0-0.1,0-0.2,0c-1.8,0.1-3.1,1.6-3,3.3C104.2,74.3,105.6,75.6,107.2,75.6  M97.4,76.1c0.1,0,0.1,0,0.2,0c1.8-0.1,3.1-1.6,3-3.3c-0.1-1.7-1.5-3-3.2-3c-0.1,0-0.1,0-0.2,0c-1.8,0.1-3.1,1.6-3,3.3 C94.3,74.8,95.7,76.1,97.4,76.1 M87.5,76.6c0.1,0,0.1,0,0.2,0c1.8-0.1,3.1-1.6,3-3.3c-0.1-1.7-1.5-3-3.2-3c-0.1,0-0.1,0-0.2,0 c-1.8,0.1-3.1,1.6-3,3.3C84.5,75.3,85.9,76.6,87.5,76.6 M77.7,77.1c0.1,0,0.1,0,0.2,0c1.8-0.1,3.1-1.6,3-3.3 c-0.1-1.7-1.5-3-3.2-3c-0.1,0-0.1,0-0.2,0c-1.8,0.1-3.1,1.6-3,3.3C74.6,75.8,76,77.1,77.7,77.1 M109,59.2c-0.2,0-0.4,0-0.6,0 l-34,1.7C68,61.3,63,66.8,63.3,73.3l0.1,2.8c0.3,6.2,5.5,11.1,11.7,11.1c0.2,0,0.4,0,0.6,0l34-1.7c6.5-0.3,11.4-5.9,11.1-12.3 l-0.1-2.8C120.4,64.1,115.3,59.2,109,59.2L109,59.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon2);
export default __webpack_public_path__ + "static/media/Education-Icon_2.abecc0adb4ba23ed60b8643fee1f09ea.svg";
export { ForwardRef as ReactComponent };